import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import WarningIcon from "@material-ui/icons/Warning";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import * as Glob from "src/Globale";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _SearchResultTable, _SpecialAcceptanceDetails } from "../components";
import { _Autocomplete } from "../form";
import { GetSpecialAcceptanceListColumns } from "../components/SearchTableColumns/SpecialAcceptanceListColumns";
import useTable from "../hooks/Table";

export const _SpecialAcceptanceList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({ ID_Deroga: "", ID_TipoDerogaTipo: "", ID_TipoDerogaStato: "" });
    const { Data, Options, IsLoading, GetData } = useTable("/api/deroga/ricerca", FormData);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={WarningIcon} Title="Deroghe" />
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="ID_Deroga"
                                    label={Trad.Trad("ID")}
                                    value={FormData.ID_Gruppo}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <_Autocomplete
                                    SearchInput
                                    Value={FormData.ID_TipoDerogaTipo}
                                    Name="ID_TipoDerogaTipo"
                                    Label="Tipo Deroga"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Tipi/ListaTipi?ID_TipoContesto=DerogaTipo"
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <_Autocomplete
                                    SearchInput
                                    Value={FormData.ID_TipoDerogaStato}
                                    Name="ID_TipoDerogaStato"
                                    Label="Stato Deroga"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Tipi/ListaTipi?ID_TipoContesto=DerogaStato"
                                />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_SearchResultTable
                        Data={Data}
                        Columns={GetSpecialAcceptanceListColumns(GetData)}
                        IsLoading={IsLoading}
                        Options={{
                            ...Options,
                            expandableRows: true,
                            renderExpandableRow: (rowData, rowMeta) => {
                                const colSpan = rowData.length + 1;
                                const data = JSON.parse(Data.Dati[rowMeta.dataIndex].DerogaJSON);

                                return <_SpecialAcceptanceDetails Data={data} ColSpan={colSpan} />;
                            }
                        }}
                    />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/SpecialAcceptanceList.tsx